<template src="./vehicleinspectioncreate.html"></template>
<script>
  import VehicleInspectionForm from "@/pages/vehicleinspections/vehicleinspectionform/vehicleinspectionform";
  export default {
    components: {
      VehicleInspectionForm,
    },
    data() {
      return {
        UniqueId: "",
      };
    },
    mounted() {
      document.title = pbx_SiteTitle + " - Vehicle Inspection";
      this.UniqueId = this.$route.params.UniqueId;
    },
  };
</script>
